export default __webpack_public_path__ + "static/media/shareAll.140cf071.svg";